export const SET_ACTIVE_SECTION = 'ProductDetails::SetActiveSection';
export const SET_DELIVERY_ACTIVE_SECTION = 'ProductDetails::SetDeliveryActiveSection';
export const SET_IS_BUNDLE_SWITCHED = 'ProductDetails::SetIsBundleSwitched';
export const SET_DELIVERY_TAKEAWAY_VIEW = 'ProductDetails::SetDeliveryTakeawayView';
export const SET_DELIVERY_TAKEAWAY_SEARCH_QUERY = 'ProductDetails::SetDeliveryTakeawaySearchQuery';
export const SET_DELIVERY_ACTIVE_POINT = 'ProductDetails::SetDeliveryActivePoint';
export const DELIVERY_PICKUP_OPEN = 'ProductDetails::DeliveryPickup::OpenState';
export const DELIVERY_PICKUP_VIEW = 'ProductDetails::DeliveryPickup::ViewState';
export const DELIVERY_PICKUP_SUCCESS = 'ProductDetails::DeliveryPickup::Success';
export const DELIVERY_PICKUP_LOADING = 'ProductDetails::DeliveryPickup::Loading';
export const DELIVERY_PICKUP_ERROR_DETAILS = 'ProductDetails::DeliveryPickup::ErrorDetails';
export const FANCY_NUMBERS_SET = 'ProductDetails::setFancyNumbers';
export const FANCY_NUMBERS_SET_ACTIVE = 'ProductDetails::setFancyNumbersActiveIndex';
export const TOGGLE_FANCYNUMBER = 'ProductDetails::toggleFancyNumber';
export const FANCY_NUMBERS_REQUEST = 'ProductDetails::requestFancyNumbers';
export const PRODUCT_DETAILS_IS_FAVORITE = 'ProductDetails::PRODUCT_DETAILS_IS_FAVORITE';
export const FANCY_NUMBERS_FAIL = 'ProductDetails::fancyNumbersRequestFailed';
export const FOLLOW_TABS_SCROLL_ID = 'followTabs';
export const FOLLOW_PROMO_SCROLL_ID = 'promoBundle';
export const FEETBACK_FORM = 'feetbackForm';
export const HEADER_HEIGHT_OFFSET = -68;
export const HEADER_MOB_APP_HEIGHT_OFFSET = -48;
export const PAYMENT_TAB_ID = 'payment-tab';
export const BNPL_HEADER_ANCHOR = 'Оплата частями';
